import { render, staticRenderFns } from "./FlexiquoteModuleListView.vue?vue&type=template&id=3cb6ca48"
import script from "./FlexiquoteModuleListView.vue?vue&type=script&lang=js"
export * from "./FlexiquoteModuleListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports